import React from "react";

export const LoginRightPanel: React.FC = () => {
  return (
    <div className="w-1/2 h-full bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#ffffff] from-[26.852%] to-[#bfdbfe] overflow-hidden">
        <div className="absolute left-[-217.778px] size-[1857.78px] top-[-128.889px]">
          <img
            alt=""
            className="block max-w-none size-full"
            src="/login-assets/ellipse-1.svg"
          />
        </div>
        <div className="absolute left-[128.148px] size-[1165.93px] top-[217.037px]">
          <img
            alt=""
            className="block max-w-none size-full"
            src="/login-assets/ellipse-2.svg"
          />
        </div>
        <div className="absolute left-[442.222px] size-[537.778px] top-[525.926px]">
          <img
            alt=""
            className="block max-w-none size-full"
            src="/login-assets/ellipse-3.svg"
          />
        </div>
        <div
          className="absolute size-[837.778px] translate-x-[-50%] translate-y-[-50%]"
          style={{
            top: "calc(50% - 61.111px)",
            left: "calc(50% - 369.259px)",
          }}
        >
          <div className="absolute inset-[-33.952%]">
            <img
              alt=""
              className="block max-w-none size-full"
              src="/login-assets/ellipse-4.svg"
            />
          </div>
        </div>
      </div>
      <div
        className="absolute box-border content-stretch flex flex-col gap-3 items-center justify-start left-1/2 p-0 translate-x-[-50%] translate-y-[-50%] w-[374px]"
        style={{ top: "calc(50% - 0.21px)" }}
      >
        <div
          className="font-['Castoro'] font-normal leading-[1.286] min-w-full not-italic relative shrink-0 text-[36px] text-center text-slate-600 tracking-[-1.1484px]"
          style={{ width: "min-content" }}
        >
          <p className="block mb-0">Unlock</p>
          <p className="block mb-0">the Future of</p>
          <p className="block mb-0">Accounting with</p>
          <p className="block">AI Innovation</p>
        </div>
        <div className="h-[13.581px] relative shrink-0 w-[72.354px]">
          <img
            alt=""
            className="block max-w-none size-full"
            src="/login-assets/invector-logo-small.svg"
          />
        </div>
      </div>
    </div>
  );
};
